import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { EvCore } from 'ev-core';
import { EvDirectivesModule } from 'ev-directives';
import { EvTooltipModule } from 'ev-tooltip';
import { SaleInArea } from 'src/models/estate/IResidenceSaleInArea';

@Component({
  selector: 'app-estate-cluster-map-marker',
  imports: [CommonModule, EvTooltipModule, EvDirectivesModule, EvCore],
  templateUrl: './estate-cluster-map-marker.component.html',
  styleUrl: './estate-cluster-map-marker.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EstateClusterMapMarkerComponent {

    readonly data = input<SaleInArea[]>();

    protected readonly summary = computed(() => {
        const data = this.data();
        if (data == null || data.length === 0) {
            return { minValue: undefined as number, maxValue: undefined as number, nrItems: 0 };
        }

        let minValue = 10000000000;
        let maxValue = 0;
        data.forEach((sale) => {
            minValue = Math.min(minValue, sale.price);
            maxValue = Math.max(maxValue, sale.price);
        });

        return { minValue, maxValue, nrItems: Math.min(99, data.length) };
    });

    getMillionPrice(price: number): string {
        if (isNaN(price)) {
            return "";
        }
        if (price === 0) {
            return "0";
        }
        if (price < 10000) {
            return "0,01";
        }
        if (price < 100000) {
            return "0,1";
        }

        const dotPrice = (price / 1000000).toFixed(1);
        return dotPrice.replace(/[.]/g, ",");
    }
}
